import { combineReducers } from 'redux';
import { authenReducer } from './authen/reducer';
import { alertReducer } from './alert/reducer';
import { authenLineReducer } from './line/reducer';
import { infoReducer } from './info/reducer';
import { titleReducer } from './title/reducer';
import { storeQrReducer } from './storeQr/reducer';
import { claimCodeReducer } from './claimCode/reducer';
import { warrantyNumberCodeReducer } from './warrantyNumberCode/reducer';
import { scanReducer } from './scan/reducer';
import { searchReducer } from './search/reducer';
import { searchCodeReducer } from './searchCode/reducer';
import { scanCodeReducer } from './scanCode/reducer';

const rootReducer = combineReducers({
  authen: authenReducer,
  alert: alertReducer,
  line: authenLineReducer,
  info: infoReducer,
  title: titleReducer,
  storeQr: storeQrReducer,
  claimCode: claimCodeReducer,
  warrantyNumberCode: warrantyNumberCodeReducer,
  scan: scanReducer,
  search: searchReducer,
  searchCode: searchCodeReducer,
  scanCode: scanCodeReducer,
});

export default rootReducer;
